import * as React from "react";
import { ReactComponent as LoaderIcon } from "../../assets/images/loading-progress.svg";
import { Theme } from "@mui/material/styles";

import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    spinner: {
      width: "100vw",
      height: "100vh",
      top: 0,
      left: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 999999,
      background: "rgba(0,0,0,0.3)",
      overflow: "hidden",
      position: "fixed",
    },
  })
);

const Loader = () => {
  const classes = useStyles();

  React.useEffect(() => {
    document.getElementsByTagName("body")[0].classList.add("loader-active");
    return () => {
      document.getElementsByTagName("body")[0].classList.remove("loader-active");
    };
  }, []);

  return (
    <div className={classes.spinner}>
      <LoaderIcon />
    </div>
  );
};

export default Loader;
